// Filename - main.js

import React, { useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { ArrowLeft, CheckCircleFill, PersonCheck, PersonCheckFill } from "react-bootstrap-icons";
import { collection, doc, getDocs, query, updateDoc, where, Timestamp } from "firebase/firestore";
import Header from './components/Header';
import Footer from './components/Footer';
import './qrreader.css'; // Import the new CSS file

const RMQrDetails = () => {

  const [name, setName] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const [clubMembers, setClubMembers] = useState([]);
  const [showClubMembers, setShowClubMembers] = useState(false);

  const [roomno, setRoomNo] = useState(""); // state for the input value
  const [message, setMessage] = useState(""); // state for the feedback message
 
 
  localStorage.setItem('prvPnr', '');
  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
      setName(user?.email);
  }, [user, loading]);
 
  const navigate = useNavigate();
  const [result, setResult] = useState("No result");

  const location = useLocation();
  const ticket = location.state.dTicket;

  const allowedFields = ["roommates", "riderprofile", "udf2",  "amount", "club", "tshirt", "food", "name"];

  const fetchClubMembers = async (clubName) => {
    try {
    
      const q = query(
        collection(db, "RiderMania", "2026", "Registrations"), 
        where("club", "==", clubName)
      );
      const querySnapshot = await getDocs(q);
      const members = querySnapshot.docs
        .map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        .filter(member => member.status === "success"); // Filter out members without PNR
       // Sort the users list 
       members.sort((a, b) => { 
        if (a.name < b.name) 
          return -1; 
        if (a.name > b.name) 
          return 1; 
        return 0; 
      });
        
      setClubMembers(members);
      setShowClubMembers(true);
    } catch (error) {
      console.error("Error fetching club members:", error);
    

      
    }
  };

  const removeStatusChecked = async (id) => {
    // Show confirmation dialog
    const isConfirmed = window.confirm("Are you sure you want to remove the check-in status?");
    
    if (!isConfirmed) {
      return; // Exit if user cancels
    }
  
    // Remove check-in data
    const checkinData = {
      checkIntime: null,            
      checkedInBY: null,
    } 
  
    try {
      const docRef = doc(db, "RiderMania", "2026", "Registrations", id); 
      await updateDoc(docRef, checkinData);
      
      // Update the local state to reflect the change
      setClubMembers(prevMembers => 
        prevMembers.map(member => 
          member.id === id 
            ? { ...member, checkIntime: null, checkedInBY: null }
            : member
        )
      );  
        
    } catch (error) {
      console.error("Error removing check-in status:", error);
      alert("Error removing check-in status");
    } 
  };

  
  const updateStatusChecked = async (id) => {
    // remote Db update  
    const checkinData = {
      checkIntime: Timestamp.fromDate(new Date()),            
      checkedInBY: name,
    } 
    try {
      const docRef = doc(db, "RiderMania", "2026", "Registrations", id); 
    await  updateDoc(docRef, checkinData);
       // Update the local state to reflect the change
       setClubMembers(prevMembers => 
        prevMembers.map(member => 
          member.id === id 
            ? { ...member, checkIntime: Timestamp.fromDate(new Date()),  checkedInBY: name,}
            : member
        )
      );  
        
    } catch (e) {
      console.error("Error updating check-in status:", e);
    } 
  
  };

  return (
      <>
      <div className="qr-details-page">
        <Header leftIcon="qr" />
        {user ? (
          <div className="container qr-details-container">
            <div className="details-card">
                {/* Ticket Details Table */}
                {!showClubMembers ? (
                <>
                  <div className="card-header-container">
                    <button className="back-button-qr" onClick={() => navigate(-1)} title="Go Back">
                      <ArrowLeft size={28} />
                    </button>
                    <div className="card-header-custom">
                      <CheckCircleFill className="icon" size={40} />
                      <h2>Rider Checked In</h2>
                    </div>
                  </div>
                  <div className="details-grid">
                    {Object.entries(ticket)
                      .filter(([key]) => allowedFields.includes(key))
                      .map(([key, value]) => (
                        <div className="ticket-details-container" key={key}>    
                        <div className="trow" style={{ color: 'var(--text-color, #f8f9fa) '}}>
                          <div className="cell uppercase">
                            <strong>{key}</strong>
                          </div>
                          <div className="cell text-break">
                            {key === "club" ? (
                              <div className="" style={{ color: 'var(--text-color, #f8f9fa) '}}>
                                <span className="me-2">{value}</span>
                                <button 
                                  className="btn btn-sm btn-primary"
                                  onClick={() => fetchClubMembers(value)}
                                >
                                  View
                                </button>
                              </div>
                            ) : (typeof value === 'object' && value !== null ? (
                                value.seconds ? new Date(value.seconds * 1000).toLocaleString() : JSON.stringify(value)
                              ) : value
                            )}
                          </div>
                        </div>
                      </div>
                      ))}
                  </div>
                </>
              ) : (
                <div className="club-members-section">
                  <div className="club-members-header">
                    <h4>{ticket.club} Members</h4>
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowClubMembers(false)}
                    >
                      Back to Rider Details
                    </button>
                  </div>
                  <div className="table-responsive club-members-table">
                    <table className="table table-hover"  style={{ color: 'var(--text-color, #f8f9fa) ',backgroundColor: 'var(--card-bg-color, #212529)'}}>
                      <thead>
                        <tr>
                          <th>Rider</th>
                          <th className="text-center">Check-in Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {clubMembers.map((member) => (
                          <tr key={member.id}>
                            <td>
                              <div className="rider-info">{member.name}</div>
                              <div className="rider-pnr">{member.riderprofile}</div>
                            </td>
                            <td className="text-center check-in-status">
                              {member.checkIntime ? (
                                <PersonCheckFill
                                  className="icon-success"
                                  size={24}
                                  onClick={() => removeStatusChecked(member.id)}
                                />
                              ) : (
                                <PersonCheck
                                  className="icon-warning"
                                  size={24}
                                  onClick={() => updateStatusChecked(member.id)}
                                />
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center" style={{height: '80vh'}}>
            <h3>404 Page Not Found</h3>
          </div>
        )}
      </div>
    <Footer />
    </>
  );
};

export default RMQrDetails;
